"use client";

import { SessionProvider } from "next-auth/react";

interface SessionProviderWrapperProps {
  children: React.ReactNode;
  session: any;
}

const SessionProviderWrapper: React.FC<SessionProviderWrapperProps> = ({ 
  children,
  session 
}) => {
  return (
    <SessionProvider session={session}>
      {children}
    </SessionProvider>
  );
};

export default SessionProviderWrapper;